import React, {Component, Fragment} from 'react';
import {BrowserRouter as Router, Route, Redirect} from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import {LOGO} from './utilities';

import Payment from './Payment'
import Kameo from './Kameo'
import Liquivida from './Liquivida';


const PSCS = [
  {code: 'PSC102', address: '102 Park Avenue, Yonkers, NY 10703', off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  {code: "PSC1108", address: "1108 Brook ave Brooklyn, NY 10456", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  // {code: "PSC112", address: "112 West 72nd st New York, New York 10023", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  // {code: 'PSC1154', address: '1154 East Tremont, Bronx, NY 10460', off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  {code: "PSC136", address: "136-21 Franklin Ave 3C-2, Flushing, NY 11355", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  // {code: 'PSC19', address: '19 Hamilton Place, New York, NY 10031', off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  // {code: "PSC201", address: "201 East 65th st New York, New York 10065", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  // {code: "PSC211", address: "211 East 51st Street New York, New York 10022", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  {code: "PSC217", address: "217 Grand Street STE 403, New York, NY 10013", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  // {code: 'PSC2180', address: '2180 SW 71st Terrace, Davie FL 33317', off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  {code: "PSC4320", address: "229 49th st, Brooklyn, NY 11220", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  // {code: 'PSC369', address: '369 East 149th Street, Bronx, NY 10455', off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  {code: "PSC395", address: "395 Pearl Street, Ste 202 Brooklyn NY 11202", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  {code: "PSC4626", address: "4626 White Plains Rd STE 100, Bronx, NY 10470", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  {code: "PSC629", address: "629 West 185th Street, New York, NY 10033", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  {code: "PSC818", address: "818 55TH Street, Brooklyn, NY 11220", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  {code: "PSC833", address: "833 58th Street, Brooklyn, NY 11220", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  {code: "PSC90", address: "90 New Main Street, Haverstraw, NY 10927", off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  {code: 'PSC9171', address: '91-71 111 Street Richmond Hill, NY, 11418', off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }},
  {code: 'PSC9229', address: '92-29 Queens Blvd STE 2D, Rego Park, NY, 11374', off: ['Saturday', 'Sunday'], startTime: '09:00:00', endTime: '17:00:00', lunchTime: {lunchStarts: '13:00:00', lunchEnds: '14:00:00', }}
];


const states = [ { "name": "Alabama", "abbreviation": "AL" }, { "name": "Alaska", "abbreviation": "AK" }, { "name": "Arizona", "abbreviation": "AZ" }, { "name": "Arkansas", "abbreviation": "AR" }, 
{ "name": "California", "abbreviation": "CA" }, { "name": "Colorado", "abbreviation": "CO" }, { "name": "Connecticut", "abbreviation": "CT" }, { "name": "Delaware", "abbreviation": "DE" }, 
{ "name": "District Of Columbia", "abbreviation": "DC" }, { "name": "Florida", "abbreviation": "FL" }, { "name": "Georgia", "abbreviation": "GA" }, { "name": "Hawaii", "abbreviation": "HI" }, 
{ "name": "Idaho", "abbreviation": "ID" }, { "name": "Illinois", "abbreviation": "IL" }, { "name": "Indiana", "abbreviation": "IN" }, { "name": "Iowa", "abbreviation": "IA" }, { "name": "Kansas", "abbreviation": "KS" }, 
{ "name": "Kentucky", "abbreviation": "KY" }, { "name": "Louisiana", "abbreviation": "LA" }, { "name": "Maine", "abbreviation": "ME" }, { "name": "Maryland", "abbreviation": "MD" }, 
{ "name": "Massachusetts", "abbreviation": "MA" }, { "name": "Michigan", "abbreviation": "MI" }, { "name": "Minnesota", "abbreviation": "MN" }, { "name": "Mississippi", "abbreviation": "MS" }, 
{ "name": "Missouri", "abbreviation": "MO" }, { "name": "Montana", "abbreviation": "MT" }, { "name": "Nebraska", "abbreviation": "NE" }, { "name": "Nevada", "abbreviation": "NV" }, 
{ "name": "New Hampshire", "abbreviation": "NH" }, { "name": "New Jersey", "abbreviation": "NJ" }, { "name": "New Mexico", "abbreviation": "NM" }, { "name": "New York", "abbreviation": "NY" }, 
{ "name": "North Carolina", "abbreviation": "NC" }, { "name": "North Dakota", "abbreviation": "ND" }, { "name": "Ohio", "abbreviation": "OH" }, { "name": "Oklahoma", "abbreviation": "OK" }, 
{ "name": "Oregon", "abbreviation": "OR" }, { "name": "Pennsylvania", "abbreviation": "PA" }, { "name": "Puerto Rico", "abbreviation": "PR" }, { "name": "Rhode Island", "abbreviation": "RI" }, 
{ "name": "South Carolina", "abbreviation": "SC" }, { "name": "South Dakota", "abbreviation": "SD" }, { "name": "Tennessee", "abbreviation": "TN" }, { "name": "Texas", "abbreviation": "TX" }, 
{ "name": "Utah", "abbreviation": "UT" }, { "name": "Vermont", "abbreviation": "VT" }, { "name": "Virginia", "abbreviation": "VA" }, { "name": "Washington", "abbreviation": "WA" }, 
{ "name": "West Virginia", "abbreviation": "WV" }, { "name": "Wisconsin", "abbreviation": "WI" }, { "name": "Wyoming", "abbreviation": "WY" } ]

const dateMask = (value) => {
  var x = value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,2})(\d{0,4})/);
  return value = !x[2] ? x[1] : x[1]+ '/' + x[2] + (x[3] ? '/' + x[3] : '')
}

const cutOff = moment().add(1, 'hours')

class Layout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showMore: false,
      lastName: "",
      isValidLastName: "",
      firstName: "",
      isValidFirstName: "",
      dob: "",
      isValidDOB: "",
      gender: "",
      isValidGender: "",
      email: "",
      isValidEmail: "",
      phone: "",
      isValidPhone: "",
      address: "",
      isValidAddress: "",
      city: "",
      isValidCity: "",
      state: "",
      isValidState: "",
      zip: "",
      isValidZip: "",
      isInsured: "",
      isValidInsured: "",
      insuranceName: "",
      isValidInsurance: "",
      policy: "",
      isValidPolicy: "",
      relation: "",
      isValidRelation: "",
      holderName: "",
      isValidHolder: "",
      race: "",
      isValidRace: "",
      ethnicity: "",
      isValidEthnicity: "",
      symptoms: {
        severe: 0,
        mild: 0,
        no: 0
      },
      isValidSymptoms: "",
      exposure: {
        no: 0,
        suspect: 0,
        yes: 0,
      },
      isValidExposure: "",
      category: {
        high: 0,
        low: 0,
      },
      isValidCategory: "",
      isHigh: false,
      isLow: false,
      psc: "",
      isValidPSC: "",
      date: moment().format("YYYY-MM-DD"),
      isValidDate: "",
      errors: [],
      busySlots: [],
      submitted: false,
      modal: false,
      loading: false,
      consent: false,
      pcr: false,
      nab: false,
      panel: false,
      time: "",
    }
  }

  onChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if(name === "dob"){
      this.setState({
        [name]:dateMask(value)
      })
    } else if (name === 'relation' && value === 'Self'){
      this.setState({
        [name]:value,
        holderName: `${this.state.firstName} ${this.state.lastName}`
      })
    } else {
      this.setState({
        [name]:value
      })
    }
    
  }

  onChangeSymptoms = (e) => {
    var key = e.target.getAttribute("name");
    var value = e.target.checked;
    let newSym = {...this.state.symptoms};
    newSym[key] = value
    this.setState({
      symptoms: newSym
    })
  }

  onChangeExposure = (e) => {
    var key = e.target.getAttribute("name");
    var value = e.target.checked;
    let newSym = {...this.state.exposure};
    newSym[key] = value
    this.setState({
      exposure: newSym
    })
  }

  onChangeTest = (e) => {
    this.setState({
      [e.target.name]: !this.state[e.target.name]
    })
  }

  onChangeRisk = (e) => {
    var key = e.target.getAttribute("name");
    var value = e.target.checked;
    let newSym = {...this.state.category};
    newSym[key] = value
    this.setState({
      category: newSym
    })
  }

  clickHigh = () => {
    this.setState({
      isHigh: !this.state.isHigh
    })
  }

  clickLow = () => {
    this.setState({
      isLow: !this.state.isLow
    })
  }

  submit = () => {
    console.log(this.state)
    this.setState({
      loading: true
    })
    let errors = [];
    let isValid = true;
    let newState = {...this.state}
    if (!this.state.firstName){
      isValid = false;
      newState.isValidFirstName = "input_error";
      errors.push('First Name is Required');
    }
    if (!this.state.lastName){
      isValid = false;
      newState.isValidLastName = "input_error";
      errors.push('Last Name is Required')
    }
    if (!this.state.dob){
      isValid = false;
      newState.isValidDOB = "input_error";
      errors.push('Date of Birth is Required')
    }
    if (!this.state.email){
      isValid = false;
      newState.isValidEmail = "input_error";
      errors.push('Email is Required')
    }
    if (!this.state.phone){
      isValid = false;
      newState.isValidPhone = "input_error";
      errors.push('Phone is Required')
    }
    if (!this.state.address){
      isValid = false;
      newState.isValidAddress = "input_error";
      errors.push('Address is Required')
    }
    if (!this.state.city){
      isValid = false;
      newState.isValidCity = "input_error";
      errors.push('City is Required')
    }
    if (!this.state.state){
      isValid = false;
      newState.isValidState = "select_error";
      errors.push('State is Required')
    }
    if (!this.state.zip){
      isValid = false;
      newState.isValidZip = "input_error";
      errors.push('Zip Code is Required')
    }
    if (!this.state.psc){
      isValid = false;
      newState.isValidPSC = "select_error";
      errors.push('Location is Required')
    }
    if (!this.state.date){
      isValid = false;
      newState.isValidDate = "input_error";
      errors.push('Date is Required')
    }
    if (isValid) {
      let formData = {...this.state};
      formData.dob = moment(this.state.dob, "MM/DD/YYYY").format("YYYY-MM-DD");
      formData.location = PSCS.filter(item => item.code === this.state.psc)[0].address;  
      axios({
        method: 'POST',
        url: `${process.env.REACT_APP_URL}/appointment`,
        data: formData,
      }).then(res => {
        window.location.href = "https://www.empirecitylabs.com/thank-you-for-your-submission/";
      }).catch(err => {
        console.log(err)
      })
    } else {
      newState.errors = errors;
      this.setState(newState)
    }
  }

  back = () => {
    this.setState({
      lastName: "",
      isValidLastName: "",
      firstName: "",
      isValidFirstName: "",
      dob: null,
      isValidDOB: "",
      gender: "",
      isValidGender: "",
      email: "",
      isValidEmail: "",
      phone: "",
      isValidPhone: "",
      address: "",
      isValidAddress: "",
      city: "",
      isValidCity: "",
      state: "",
      isValidState: "",
      zip: "",
      isValidZip: "",
      isInsured: "",
      isValidInsured: "",
      insuranceName: "",
      isValidInsurance: "",
      policy: "",
      isValidPolicy: "",
      relation: "",
      isValidRelation: "",
      holderName: "",
      isValidHolder: "",
      race: "",
      isValidRace: "",
      ethnicity: "",
      isValidEthnicity: "",
      symptoms: {
        severe: 0,
        mild: 0,
        no: 0
      },
      isValidSymptoms: "",
      exposure: {
        no: 0,
        suspect: 0,
        yes: 0,
      },
      isValidExposure: "",
      category: {
        high: 0,
        low: 0,
      },
      isValidCategory: "",
      isHigh: false,
      isLow: false,
      psc: "",
      isValidPSC: "",
      date: null,
      isValidDate: "",
      errors: [],
      busySlots: [],
      submitted: false,
      modal: false,
    })
  }

  onModal = () => {
    this.setState({
      modal: !this.state.modal
    })
  }

  handleConsent = (e) => {
    this.setState({
      consent: !this.state.consent
    })
  }

  onShowMore = () => {
    this.setState({
      showMore: !this.state.showMore
    })
  }

  renderModal(){
    return(
      <div className={`modal inmodal`} id="myModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" style={{display:"block"}}>
       <div className="modal-dialog modal-lg" role="document">
         <div className="modal-content">
           <div className="modal-header">
             <button type="button" className="close" data-dismiss="modal" onClick={this.onModal}>
               <span aria-hidden="true">x</span>
             </button>
           </div>
           <div className="modal-body modal-reduced-padding"  style={{overflowY: 'auto', height: '500px'}}>
            <iframe src="https://www.google.com/maps/d/u/0/embed?mid=17kFXCJos6ID8nDD3hR-HOCpu3kNJcAxP" width="100%" height="100%"></iframe>
           </div>
         </div>
       </div>
     </div>
    )
  }

  consent = () => {
    window.open(`${process.env.REACT_APP_URL_API || ''}/v0/consent`)
  }

  selectTime = (time) => {
    this.setState({
      time: time
    })
  }

  render() {
    return (
      <div className="wrapper">
        <Router>
          <div>
            {this.state.submitted ?
              <div>
                <div>
                  <div>
                    <img src={LOGO} height="100"/>
                  </div>
                </div>
                <div>
                  <div>
                    <h3>Your appointment was scheduled. You should receive an email confirmation shortly.</h3>
                  </div>
                </div> 
                <div>
                  <div>
                    <button className="btn btn-primary" onClick={this.back}>BACK</button>
                  </div>
                </div>                     
              </div> 
              :
              <div>
                <Route exact path="/kameo" component={Kameo}/>
                <Route exact path="/liquivida" component={Liquivida}/>
                <Route exact path="/" render={({match, location, history}) => {
                    return (
                      <Fragment>
                        
                        <div className='header'>
                            <img src={LOGO}/>
                          <div>
                            <p className='petuhi_bold'>Trusted. Reliable. Innovative.</p>
                            <p className='petuhi'><span>Customer Care: </span>888.522.8082</p>
                          </div>
                        </div>
                        <div className='container'> 
                          <div className='box'>
                            <div className='col50'>
                              <div className='col50'>
                                <div>
                                  <div>
                                    <div className='col50'>
                                      <div className='column'> 
                                        <div className='h1'>
                                          <p>Book your Appointment</p>
                                          {window.location.href.split('?')[1] === 'florida' ? <h1 style={{fontWeight: 'bold', color: "#2471A3"}} >For 1-Hour PCR Test</h1>: ''}
                                        </div>
                                        <div className='h2'>
                                          <p>*If you are seriously ill, please seek immediate medical care from a healthcare professional.</p>
                                          <p>**If you are having a medical emergency, please call 9-1-1. Signs of a serious medical condition include, but are not limited to, severe shortness of breath or difficulty breathing, coughing up blood, chest pain, irregular heartbeat, persistent vomiting, or diarrhea.</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='col50'>
                                    <div className='form'>
                                        <label className='label'>Select Location</label>
                                        {window.location.href.split('?')[1] === 'florida' ? 
                                        <select className={` ${this.state.isValidPSC}`} name="psc" value={this.state.psc} onChange={this.onChange}>
                                          <option value='PSC2180'>2180 SW 71st Terrace, Davie FL 33317</option>
                                        </select> :
                                        /* <select className={`select ${this.state.isValidPSC}`} name="psc" value={this.state.psc} onChange={this.onChange}>
                                          {PSCS.map(item => <option key={item.code} value={item.code}>{item.address}</option>)}
                                        </select> */
                                        <select className='select'>
                                          <option>• Manhattan</option>
                                          <option>629 West 185th St, New York, NY 10033</option>
                                          <option>217 Grand St, Suite 403, New York, NY 10013</option>
                                          <option>• Brooklyn</option>
                                          <option>229 49th St, Brooklyn, NY 11220</option>
                                          <option>818 55th St, Basement, Brooklyn, NY 11220</option>
                                          <option>833 58th St, Brooklyn, NY 11220</option>
                                          <option>395 Pearl St, Suite 202, Brooklyn, NY 11202</option>
                                          <option>• Bronx</option>
                                          <option>1108 Brook Ave, Bronx, NY 10456</option>
                                          <option>4626 White Plains Rd, Suite 100, Bronx, NY 10470</option>
                                          <option>• Queens</option>
                                          <option>136-21 Franklin Ave, 3C-2, Flushing, NY 11355</option>
                                          <option>92-29 Queens Blvd, Queens, NY 11374</option>
                                          <option>91-71 111st St, Queens, NY 11418</option>
                                          <option>• Upstate</option>
                                          <option>102 Park Ave, Yonkers, NY 10703</option>
                                          <option>90 New Main St, Haverstraw, NY 10927</option>
                                        </select>
                                        }
                                      </div>
                                      <div class="spacer_70"></div>
                                      <div className='form'>
                                        <label className='label'>Select Date</label>
                                        <input className={`input ${this.state.isValidDate}`} min={moment().format('YYYY-MM-DD')} type="date" name="date" value={this.state.date} onChange={this.onChange}/>
                                      </div>
                                    </div>
                                    <div className='form'>
                                      <label className='label'>Select Time</label>
                                      <div className='time'>
                                        <div className='row'>
                                          <button className='button_light'>8:00 AM</button>
                                          <button className='button_light'>8:15 AM</button>
                                          <button className='button_light'>8:30 AM</button>
                                          <button className='button_light'>8:45 AM</button>
                                          <button className='button_light'>9:00 AM</button>
                                          <button className='button_light'>9:15 AM</button>
                                          <button className='button_light'>9:30 AM</button>
                                          <button className='button_light'>9:45 AM</button>
                                        </div>
                                        <div className='row'>
                                          <button className='button_light'>10:00 AM</button>
                                          <button className='button_light'>10:15 AM</button>
                                          <button className='button_light'>10:30 AM</button>
                                          <button className='button_light'>10:45 AM</button>
                                          <button className='button_light'>11:00 AM</button>
                                          <button className='button_light'>11:15 AM</button>
                                          <button className='button_light'>11:30 AM</button>
                                          <button className='button_light'>11:45 AM</button>
                                        </div>
                                        <div className='row'>
                                          <button className='button_light'>View more appointment times</button>
                                        </div>
                                        <div className='row'>
                                          <button className='button_light'>12:00 PM</button>
                                          <button className='button_light'>12:15 PM</button>
                                          <button className='button_light'>12:30 PM</button>
                                          <button className='button_light'>12:45 PM</button>
                                          <button className='button_light'>1:00 PM</button>
                                          <button className='button_light'>1:15 PM</button>
                                          <button className='button_light'>1:30 PM</button>
                                          <button className='button_light'>1:45 PM</button>
                                        </div>
                                        <div className='row'>
                                          <button className='button_light'>2:00 PM</button>
                                          <button className='button_light'>2:15 PM</button>
                                          <button className='button_light'>2:30 PM</button>
                                          <button className='button_light'>2:45 PM</button>
                                          <button className='button_light'>3:00 PM</button>
                                          <button className='button_light'>3:15 PM</button>
                                          <button className='button_light'>3:30 PM</button>
                                          <button className='button_light'>3:45 PM</button>
                                        </div>
                                        <div className='row'>
                                          <button className='button_light'>4:00 PM</button>
                                          <button className='button_light'>4:15 PM</button>
                                          <button className='button_light'>4:30 PM</button>
                                          <button className='button_light'>4:45 PM</button>
                                        </div>
                                        <div className='row'>
                                          <button className='button_light'>Show less</button>
                                        </div>
                                        {this.state.showMore && <Fragment>
                                          <div className='row'>
                                            <button className='button_blocked'> 1PM-2PM: Lunch Break </button>
                                          </div>
                                          {/* <div className='row'>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(12).minute(0)) ? `button_blocked`:`button_light${this.state.time === "12:00PM" ? '_active':''}`} onClick={() => this.selectTime("12:00PM")}>12:00 PM</button>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(12).minute(15)) ? `button_blocked`:`button_light${this.state.time === "12:15PM" ? '_active':''}`} onClick={() => this.selectTime("12:15PM")}>12:15 PM</button>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(12).minute(30)) ? `button_blocked`:`button_light${this.state.time === "12:30PM" ? '_active':''}`} onClick={() => this.selectTime("12:30PM")}>12:30 PM</button>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(12).minute(45)) ? `button_blocked`:`button_light${this.state.time === "12:45PM" ? '_active':''}`} onClick={() => this.selectTime("12:45PM")}>12:45 PM</button>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(13).minute(0)) ? `button_blocked`:`button_light${this.state.time === "1:00PM" ? '_active':''}`} onClick={() => this.selectTime("1:00PM")}>1:00 PM</button>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(13).minute(15)) ? `button_blocked`:`button_light${this.state.time === "1:15PM" ? '_active':''}`} onClick={() => this.selectTime("1:15PM")}>1:15 PM</button>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(13).minute(30)) ? `button_blocked`:`button_light${this.state.time === "1:30PM" ? '_active':''}`} onClick={() => this.selectTime("1:30PM")}>1:30 PM</button>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(13).minute(45)) ? `button_blocked`:`button_light${this.state.time === "1:45PM" ? '_active':''}`} onClick={() => this.selectTime("1:45PM")}>1:45 PM</button>
                                          </div> */}
                                          <div className='row'>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(14).minute(0)) ? `button_blocked`:`button_light${this.state.time === "2:00PM" ? '_active':''}`} onClick={() => this.selectTime("2:00PM")}>2:00 PM</button>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(14).minute(15)) ? `button_blocked`:`button_light${this.state.time === "2:15PM" ? '_active':''}`} onClick={() => this.selectTime("2:15PM")}>2:15 PM</button>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(14).minute(30)) ? `button_blocked`:`button_light${this.state.time === "2:30PM" ? '_active':''}`} onClick={() => this.selectTime("2:30PM")}>2:30 PM</button>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(14).minute(45)) ? `button_blocked`:`button_light${this.state.time === "2:45PM" ? '_active':''}`} onClick={() => this.selectTime("2:45PM")}>2:45 PM</button>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(15).minute(0)) ? `button_blocked`:`button_light${this.state.time === "3:00PM" ? '_active':''}`} onClick={() => this.selectTime("3:00PM")}>3:00 PM</button>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(15).minute(15)) ? `button_blocked`:`button_light${this.state.time === "3:15PM" ? '_active':''}`} onClick={() => this.selectTime("3:15PM")}>3:15 PM</button>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(15).minute(30)) ? `button_blocked`:`button_light${this.state.time === "3:30PM" ? '_active':''}`} onClick={() => this.selectTime("3:30PM")}>3:30 PM</button>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(15).minute(45)) ? `button_blocked`:`button_light${this.state.time === "3:45PM" ? '_active':''}`} onClick={() => this.selectTime("3:45PM")}>3:45 PM</button>
                                          </div>
                                          <div className='row'>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(16).minute(0)) ? `button_blocked`:`button_light${this.state.time === "4:00PM" ? '_active':''}`} onClick={() => this.selectTime("4:00PM")}>4:00 PM</button>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(16).minute(15)) ? `button_blocked`:`button_light${this.state.time === "4:15PM" ? '_active':''}`} onClick={() => this.selectTime("4:15PM")}>4:15 PM</button>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(16).minute(30)) ? `button_blocked`:`button_light${this.state.time === "4:30PM" ? '_active':''}`} onClick={() => this.selectTime("4:30PM")}>4:30 PM</button>
                                            <button className={moment(cutOff).isAfter(moment(this.state.date).hour(16).minute(45)) ? `button_blocked`:`button_light${this.state.time === "4:45PM" ? '_active':''}`} onClick={() => this.selectTime("4:45PM")}>4:45 PM</button>
                                          </div>
                                          <div className='row'>
                                            <button className={`button_light`} onClick={this.onShowMore}>Show less</button>
                                          </div>
                                        </Fragment>}
                                        
                                      </div>
                                      <div className='time_mobile'>
                                        <div className='row'>
                                          <button className='button_light'>8:00 AM</button>
                                          <button className='button_light'>8:15 AM</button>
                                          <button className='button_light'>8:30 AM</button>
                                          <button className='button_light'>8:45 AM</button>
                                          <button className='button_light'>9:00 AM</button>
                                        </div>
                                        <div className='row'>
                                          <button className='button_light'>9:15 AM</button>
                                          <button className='button_light'>9:30 AM</button>
                                          <button className='button_light'>9:45 AM</button>
                                          <button className='button_light'>10:00 AM</button>
                                          <button className='button_light'>10:15 AM</button>
                                        </div>
                                        <div className='row'>
                                          <button className='button_light'>View more appointment times</button>
                                        </div>
                                        <div className='row'>
                                          <button className='button_light'>10:30 AM</button>
                                          <button className='button_light'>10:45 AM</button>
                                          <button className='button_light'>11:00 AM</button>
                                          <button className='button_light'>11:15 AM</button>
                                          <button className='button_light'>11:30 AM</button>
                                        </div>
                                        <div className='row'>
                                          <button className='button_light'>11:45 AM</button>
                                          <button className='button_light'>12:00 PM</button>
                                          <button className='button_light'>12:15 PM</button>
                                          <button className='button_light'>12:30 PM</button>
                                          <button className='button_light'>12:45 PM</button>
                                        </div>
                                        <div className='row'>
                                          <button className='button_light'>1:00 PM</button>
                                          <button className='button_light'>1:15 PM</button>
                                          <button className='button_light'>1:30 PM</button>
                                          <button className='button_light'>1:45 PM</button>
                                          <button className='button_light'>2:00 PM</button>
                                        </div>
                                        <div className='row'>
                                          <button className='button_light'>2:15 PM</button>
                                          <button className='button_light'>2:30 PM</button>
                                          <button className='button_light'>2:45 PM</button>
                                          <button className='button_light'>3:00 PM</button>
                                          <button className='button_light'>3:15 PM</button>
                                        </div>
                                        <div className='row'>
                                          <button className='button_light'>3:30 PM</button>
                                          <button className='button_light'>3:45 PM</button>
                                          <button className='button_light'>4:00 PM</button>
                                          <button className='button_light'>4:15 PM</button>
                                          <button className='button_light'>4:30 PM</button>
                                        </div>
                                        <div className='row'>
                                          <button className='button_light'>4:45 PM</button>
                                        </div>
                                        <div className='row'>
                                          <button className='button_light'>Show less</button>
                                        </div>
                                      </div>
                                    </div>                             
                                    
                                    {/* <div>
                                      <div className='form'>
                                        <label>Select Location</label>
                                        {window.location.href.split('?')[1] === 'florida' ? 
                                        <select className={` ${this.state.isValidPSC}`} name="psc" value={this.state.psc} onChange={this.onChange}>
                                          <option value='PSC2180'>2180 SW 71st Terrace, Davie FL 33317</option>
                                        </select> :
                                        <select className={` ${this.state.isValidPSC}`} name="psc" value={this.state.psc} onChange={this.onChange}>
                                          {PSCS.map(item => <option key={item.code} value={item.code}>{item.address}</option>)}
                                        </select>
                                        }
                                      </div>
                                      { this.state.psc && 
                                      <Fragment>
                                        <div className='form'>
                                          <label>Select Date</label>
                                          <input className={` ${this.state.isValidDate}`} min={moment().format('YYYY-MM-DD')} type="date" name="date" value={this.state.date} onChange={this.onChange}/>
                                        </div>                                    
                                      </Fragment>
                                      }
                                    </div> */}

                                    {/* <div className='form'>
                                      <label>Are You Insured?</label>
                                      <select className={` ${this.state.isValidInsured}`} name="isInsured" value={this.state.isInsured} onChange={this.onChange}>
                                        <option value="No">No</option>
                                        <option value="Yes">Yes</option>
                                      </select>
                                    </div>
                                    {this.state.isInsured === 'Yes' &&
                                    <div>
                                      <div className='col50'>                   
                                        <div className='form'>
                                          <label>Insurance Name</label>
                                          <input className={` ${this.state.isValidInsurance}`} name="insuranceName" type="text" placeholder="Enter insurance name" value={this.state.insuranceName} onChange={this.onChange}/>
                                        </div>
                                        <div class="spacer_70"></div>
                                        <div className='form'>
                                          <label>Policy Member ID</label>
                                          <input className={` ${this.state.isValidPolicy}`} name="policy" type="text" placeholder="Enter policy ID" value={this.state.policy} onChange={this.onChange}/>
                                        </div>
                                      </div>
                                      <div className='col50'>
                                        <div className='form'>
                                          <label>Relation to Insured</label>
                                          <select className={` ${this.state.isValidRelation}`} name="relation" value={this.state.relation} onChange={this.onChange}>
                                            <option value="Self">Self</option>
                                            <option value="Spouse">Spouse</option>
                                            <option value="Child">Child</option>
                                            <option value="Other">Other</option>
                                          </select>
                                        </div>
                                        <div class="spacer_70"></div>
                                        <div className='form'>
                                          <label>Policy Holder Name</label>
                                          <input className={` ${this.state.isValidHolder}`} name="holderName" value={this.state.holderName} onChange={this.onChange}/>
                                        </div>
                                      </div>
                                    </div>} */}

                                    <div className='col50'>
                                      <div className='form'>
                                        <label className='label'>Last Name</label>
                                        <input className={`input ${this.state.isValidLastName}`} name="lastName" type="text" placeholder="Enter your last name" value={this.state.lastName} onChange={this.onChange}/>
                                      </div>
                                      <div class="spacer_70"></div>
                                      <div className='form'>
                                        <label className='label'>First Name</label>
                                        <input className={`input ${this.state.isValidFirstName}`} name="firstName" type="text" placeholder="Enter your first name" value={this.state.firstName} onChange={this.onChange}/>
                                      </div>
                                    </div>
                                    <div className='form'>
                                      <label className='label'>Date Of Birth</label>
                                      <input className={`input ${this.state.isValidDOB}`} placeholder="MM/DD/YYYY" name="dob" value={this.state.dob} onChange={this.onChange}/>
                                    </div>
                                    <div className='col50'>
                                      <div className='form'>
                                        <label className='label'>Email</label>
                                        <input className={`input ${this.state.isValidEmail}`} name="email" type="text" placeholder="Enter your email" value={this.state.email} onChange={this.onChange}/>
                                      </div>
                                      <div class="spacer_70"></div>
                                      <div className='form'>
                                        <label className='label'>Phone</label>
                                        <input className={`input ${this.state.isValidPhone}`} name="phone" value={this.state.phone} placeholder="XXXXXXXXXX" onChange={this.onChange}/>
                                      </div>
                                    </div>
                                    <div className='form'>
                                      <label className='label'>Home Address</label>
                                      <input className={`input ${this.state.isValidAddress}`} name="address" type="text" placeholder="Enter the address" value={this.state.address} onChange={this.onChange}/>
                                    </div>
                                    <div className='col50'>
                                      <div className='form'>
                                        <label className='label'>City</label>
                                        <input className={`input ${this.state.isValidCity}`} name="city" type="text" placeholder="Enter city" value={this.state.city} onChange={this.onChange}/>
                                      </div>
                                      <div class="spacer_70"></div>
                                      <div className='form'>
                                        <label className='label'>State</label>
                                        <select className={` ${this.state.isValidState}`} name="state" value={this.state.state} onChange={this.onChange}>
                                          <option value="">Select</option>
                                          {states.map(item => <option key={item.abbreviation} value={item.abbreviation}>{item.name}</option>)}
                                        </select>
                                      </div>
                                      <div class="spacer_70"></div>
                                      <div className='form'>
                                        <label className='label'>Zip Code</label>
                                        <input className={`input ${this.state.isValidZip}`} name="zip" type="text" placeholder="Enter zip code" value={this.state.zip} onChange={this.onChange}/>
                                      </div>
                                    </div>

                                    {/* <div>
                                      <div>
                                        <ul>
                                          {this.state.errors.map((err, index) => <li key={index}>{err}</li>)}
                                        </ul>
                                      </div>
                                    </div> */}

                                    <div className='form'>
                                      <button className='button' disabled={this.state.loading} onClick={this.submit}>{this.state.loading ? '...Submitting' : 'Submit an Appointment'}</button>
                                    </div>
                                  </div>                    
                                </div>
                                {this.state.modal && this.renderModal()}
                              </div>
                              <div className='spacer_40'></div>
                              <div className='col30'>
                                {window.location.href.split('?')[1] === 'florida' ? 
                                  <iframe src="https://www.google.com/maps/d/u/0/embed?mid=1Ji8By_uks3JitUVL-y_1NKL3dt8gLtgN&ehbc=2E312F"></iframe> :
                                  <iframe src="https://www.google.com/maps/d/u/0/embed?mid=17kFXCJos6ID8nDD3hR-HOCpu3kNJcAxP"></iframe>
                                }                      
                              </div>
                            </div>
                          </div>
                        </div>

                      </Fragment>
                    )
                  }}/>
              </div>
            }
          </div>
        </Router>
      </div>
    )
  }
}
export default Layout